import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';
import './styles.css';

class ApplicationRequirements extends React.PureComponent {
  static propTypes = {
    admissionsData: PropTypes.object,
  };

  state = {
    selectedFreshman: true,
    selectedTransfer: false,
    selectedInternational: false,
  };

  clearSelection = () => {
    this.setState({
      selectedFreshman: false,
      selectedTransfer: false,
      selectedInternational: false,
    });
  };

  selectFreshman = () => {
    this.clearSelection();
    this.setState({ selectedFreshman: true });
  };

  selectTransfer = () => {
    this.clearSelection();
    this.setState({ selectedTransfer: true });
  };

  selectInternational = () => {
    this.clearSelection();
    this.setState({ selectedInternational: true });
  };

  getSelectedRequirements(
    freshmanRequirements,
    transferRequirements,
    internationalRequirements,
  ) {
    if (this.state.selectedFreshman) return freshmanRequirements;
    if (this.state.selectedTransfer) return transferRequirements;
    return internationalRequirements;
  }

  renderOptions() {
    const activeStyle = 'option-active';
    const inactiveStyle = 'option-inactive';
    return (
      <div className="options">
        <div
          className={`option option-left ${
            this.state.selectedFreshman ? activeStyle : inactiveStyle
          }`}
          onClick={this.selectFreshman}
          data-cy="admissions-application-requirements-option-freshman"
        >
          <FormattedMessage {...messages.optionFreshman} />
        </div>
        <div
          className={`option ${
            this.state.selectedTransfer ? activeStyle : inactiveStyle
          }`}
          onClick={this.selectTransfer}
          data-cy="admissions-application-requirements-option-transfer"
        >
          <FormattedMessage {...messages.optionTransfer} />
        </div>
        <div
          className={`option option-right ${
            this.state.selectedInternational ? activeStyle : inactiveStyle
          }`}
          onClick={this.selectInternational}
          data-cy="admissions-application-requirements-option-international"
        >
          <FormattedMessage {...messages.optionInternational} />
        </div>
      </div>
    );
  }

  renderColumns(selectedRequirements) {
    const requiredRequirements = selectedRequirements.filter(
      (requirement) => requirement.value === 'Required',
    );
    const recommendedRequirements = selectedRequirements.filter(
      (requirement) => requirement.value === 'Recommended',
    );
    const optionalRequirements = selectedRequirements.filter(
      (requirement) => requirement.value === 'Optional',
    );
    return (
      <div className="columns">
        <div
          className="column"
          data-cy="admissions-application-requirements-column-required"
        >
          <h4 className="column-header">
            <FormattedMessage {...messages.columnRequired} />
          </h4>
          <ul className="column-list">
            {requiredRequirements.map(this.renderRequirement)}
          </ul>
        </div>
        <div
          className="column"
          data-cy="admissions-application-requirements-column-recommended"
        >
          <h4 className="column-header">
            <FormattedMessage {...messages.columnRecommended} />
          </h4>
          <ul className="column-list">
            {recommendedRequirements.map(this.renderRequirement)}
          </ul>
        </div>
        <div
          className="column"
          data-cy="admissions-application-requirements-column-optional"
        >
          <h4 className="column-header">
            <FormattedMessage {...messages.columnOptional} />
          </h4>
          <ul className="column-list">
            {optionalRequirements.map(this.renderRequirement)}
          </ul>
        </div>
      </div>
    );
  }

  renderRequirement(requirement, index) {
    return (
      <li key={index} className="column-item">
        {requirement.type}
      </li>
    );
  }

  render() {
    const applicationRequirements = get(
      this.props.admissionsData,
      'applicationRequirements',
      {},
    );
    const prepareRequirement = (requirements) =>
      requirements &&
      requirements
        .filter((requirement) => requirement.value)
        .sort((r1, r2) => r1.type.localeCompare(r2.type));
    const freshmanRequirements =
      prepareRequirement(applicationRequirements.freshman) || [];
    const transferRequirements =
      prepareRequirement(applicationRequirements.transfer) || [];
    const internationalRequirements =
      prepareRequirement(applicationRequirements.international) || [];
    if (
      !freshmanRequirements.length &&
      !transferRequirements.length &&
      !internationalRequirements.length
    )
      return null;
    const selectedRequirements = this.getSelectedRequirements(
      freshmanRequirements,
      transferRequirements,
      internationalRequirements,
    );
    return (
      <div id="admissions-application-requirements">
        <div className="common-core-width container">
          <h2 className="title" data-cy="admissions-application-requirements-title">
            <FormattedMessage {...messages.title} />
          </h2>
          <div
            className="subtitle"
            data-cy="admissions-application-requirements-subtitle"
          >
            <FormattedMessage {...messages.subtitle} />
          </div>
          {this.renderOptions()}
          {this.renderColumns(selectedRequirements)}
        </div>
      </div>
    );
  }
}

export default injectIntl(ApplicationRequirements);
